module.exports = __webpack_public_path__ + "static/media/4.97b10df4.jpg";